// Publishes a Shopify customer event when a content product card is clicked.
// A custom pixel (Settings > Customer events) forwards `content_product_click` to GA4.
(function () {
  if (window.__contentProductCards) return;
  window.__contentProductCards = true;
  document.addEventListener('click', function (event) {
    var card = event.target.closest && event.target.closest('[data-cp-click]');
    if (!card) return;
    var data = {
      product_id: card.dataset.productId,
      product_title: card.dataset.productTitle,
      price: parseFloat(card.dataset.price) || 0,
      placement: card.dataset.placement,
      position: parseInt(card.dataset.position, 10) || 1,
      page_type: card.dataset.pageType,
      page_path: window.location.pathname
    };
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('content_product_click', data);
      }
    } catch (e) {}
    (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'content_product_click' }, data));
  });
})();
